var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommentIconInline = function SvgCommentIconInline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 2C4.976 2 1 5.632 1 9.998c0 1.608.534 3.108 1.459 4.367.117.159.144.369.067.554l-1.168 2.8 3.478-.97a.567.567 0 0 1 .426.05A9.8 9.8 0 0 0 10 17.997c5.024 0 9-3.632 9-7.999C19 5.632 15.024 2 10 2ZM0 9.998C0 4.978 4.531 1 10 1s10 3.978 10 8.998c0 5.021-4.531 8.999-10 8.999-1.845 0-3.577-.45-5.064-1.237L.7 18.94a.533.533 0 0 1-.635-.72l1.445-3.464C.555 13.38 0 11.748 0 9.998Z",
    clipRule: "evenodd"
  })));
};
export default SvgCommentIconInline;